import './resources-requests.service';
import './resources-dialog.service';
import './resources-service.service';
import './resources-api.factory';
import './resources-allocations-instances-api.factory';
import './resources-alerts.service';
import './resources-allocations-api.factory';
import './schedule-binding-api.factory';
